// DEPRECATED

import appendStyling from "../helpers/appendStyling";

const cookieBar = {
	context: {},
	tests: [
		() => {
			// cookieBanner_A
			/* do nuthink */
		},
		() => {
			// cookieBanner_B
			appendStyling(`
				#cookie-law-info-bar {
					background: white !important;
					border-radius: 8px !important;
				}
		
				#cookie-law-info-bar .cli-bar-message {
					font-size: 16px !important;
					text-align: center !important;
				}
		
				#wt-cli-settings-btn {
					color: var(--bs-primary) !important;
					background: white !important;
				}
				#wt-cli-settings-btn.cli_settings_button:hover {
					background: white !important;
				}
			`);

			// disable hover actions clear styling, set correct classes
			const settingsBtn = document.getElementById("wt-cli-settings-btn");
			const acceptBtn = document.getElementById("wt-cli-accept-all-btn");

			settingsBtn.className = "cli_settings_button";
			settingsBtn.style = "";

			acceptBtn.className = "cli_action_button cookie_action_close_header btn btn-primary d-block ";
			acceptBtn.style = "margin: 20px 40px 0 !important;";
		},
	],
	canBeEnabled: () => !!document.getElementById("cookie-law-info-bar"),
};

export default cookieBar;
